import { createInitialGameState } from "../game/state.js";

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {string} pairingId
 */
export async function fetchActiveGameForPairing(supabase, pairingId) {
  const { data, error } = await supabase
    .from("games")
    .select("id, state_json, state_version, status, updated_at, pairing_id")
    .eq("pairing_id", pairingId)
    .eq("status", "active")
    .order("updated_at", { ascending: false })
    .limit(1)
    .maybeSingle();
  return { game: data, error };
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {string} pairingId
 * @returns {Promise<string>} game id
 */
export async function createPairingGame(supabase, pairingId) {
  const { data: gameId, error } = await supabase.rpc("create_pairing_game", {
    p_pairing_id: pairingId,
  });
  if (error) throw error;
  const gid = typeof gameId === "string" ? gameId : gameId != null ? String(gameId) : "";
  if (!gid) {
    throw new Error("create_pairing_game did not return a game id");
  }
  const initial = createInitialGameState();
  const { points, bar, trayLeft, trayRight } = initial;
  const { error: upErr } = await supabase
    .from("games")
    .update({
      state_json: { points, bar, trayLeft, trayRight },
      state_version: 1,
    })
    .eq("id", gid);
  if (upErr) throw upErr;
  return gid;
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {string} gameId
 */
export async function fetchGameById(supabase, gameId) {
  const { data, error } = await supabase
    .from("games")
    .select("id, state_json, state_version, status, pairing_id")
    .eq("id", gameId)
    .maybeSingle();
  return { game: data, error };
}
